import bigDecimal from "js-big-decimal";

export default class BigDecimal extends bigDecimal{
    /**
     * @param {BigDecimal|bigDecimal|string ?}str
     */
    constructor(str) {
        if(str instanceof bigDecimal){
            super(str.getValue());
        } else {
            super(str);
        }
    }

    _normalize(parameter){
        if(parameter instanceof BigDecimal){
            return parameter;
        }
        return new BigDecimal(parameter);
    }

    toString(){
        return this.getValue();
    }

    toJSON(){
        return this.getValue();
    }

    /**
     * @param {number?} precision
     * @param {RoundingModes?} mode
     * @return {bigDecimal}
     */
    round(precision, mode){
        return new BigDecimal(super.round(precision, mode));
    }

    /**
     * @return {BigDecimal}
     */
    floor(){
        return new BigDecimal(super.floor());
    }
    /**
     * @return {BigDecimal}
     */
    ceil(){
        return new BigDecimal(super.ceil());
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {BigDecimal}
     */
    add(number){
        return new BigDecimal(super.add(this._normalize(number)));
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {BigDecimal}
     */
    subtract(number){
        return new BigDecimal(super.subtract(this._normalize(number)));
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {BigDecimal}
     */
    multiply(number){
        return new BigDecimal(super.multiply(this._normalize(number)));
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {BigDecimal}
     */
    divide(number, precision){
        return new BigDecimal(super.divide(this._normalize(number), precision));
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {BigDecimal}
     */
    modulus(number){
        return new BigDecimal(super.modulus(this._normalize(number)));
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {0 | 1 | -1}
     */
    compareTo(number){
        return super.compareTo(this._normalize(number));
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {Boolean}
     */
    equals(number){
        return super.compareTo(this._normalize(number)) === 0;
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {Boolean}
     */
    greaterThen(number){
        return super.compareTo(this._normalize(number)) > 0;
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {Boolean}
     */
    greaterThenOrEquals(number){
        return super.compareTo(this._normalize(number)) >= 0;
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {Boolean}
     */
    lowerThen(number){
        return super.compareTo(this._normalize(number)) < 0;
    }

    /**
     * @param {BigDecimal|string|Number} number
     * @return {Boolean}
     */
    lowerThenOrEquals(number){
        return super.compareTo(this._normalize(number)) <= 0;
    }

    /**
     * @return {BigDecimal}
     */
    negate(){
        return new BigDecimal(super.negate());
    }
}